import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import { Avatar } from 'shared-components/image/avatar';
import { Responsiveness } from '../../elements-responsiveness/responsiveness';

export const InquiryHostBanner = ({
  ownerAvatar = '',
  listingImageId = '',
  firstName = '',
  lastName = '',
  responsiveness = {},
  intl
}) => {
  const listingImageUrl = listingImageId
    ? `https://res.cloudinary.com/peerspace-inc/image/upload/q_80,c_crop,g_custom/w_100,h_100,c_fill/${listingImageId}`
    : '';

  return (
    <section className='InquiryHostBanner flex middle'>
      <div className='banner-avatar-container'>
        <img
          className='listing-img'
          src={listingImageUrl}
          alt={intl.formatMessage({
            id: 'inquiry_booking.host_banner.listing',
            defaultMessage: 'Listing'
          })}
          style={{ height: '100%', width: '100%' }}
        />
        <Avatar id={ownerAvatar} className='host-avatar' />
      </div>
      <div>
        <div className='host-name no-margin gutter'>
          <FormattedMessage
            id='inquiry_booking.host_banner.message_header'
            defaultMessage='Message {firstName} {lastName}'
            values={{ firstName, lastName }}
          />
        </div>
        <div>
          <Responsiveness
            noTooltip
            ownerName=' '
            level={responsiveness.level}
            responseTime={responsiveness.hours}
            labelClassName='host-responsiveness capitalize-first-letter'
          />
        </div>
      </div>
    </section>
  );
};

InquiryHostBanner.propTypes = {
  ownerAvatar: PropTypes.string,
  listingImageId: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  responsiveness: PropTypes.object,
  intl: intlShape
};
